<template>
  <div class="table-wrapper">
    <div class="header">
      <h4 class="title">{{ title }}</h4>
      <slot name="header-actions" />
    </div>
    <div v-if="data && data.length > 0" class="table-content">
      <table>
        <thead>
          <tr>
            <th v-for="(item, index) in tableHeaders" :key="index">
              {{ item }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in data"
            :key="index"
            style="cursor: pointer"
            @click="onClickItem(item)"
          >
            <slot v-bind:item="item" v-bind:index="index"></slot>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="flex items-center justify-center p-6">
      <h4>{{ "جدول خالی است." }}</h4>
    </div>
    <div class="footer">
      <pagination-numbers
        :page="page"
        :totalItems="totalItems"
        :itemsPerPage="itemsPerPage"
        @onChangedPage="onChangedPage"
      />
    </div>
  </div>
</template>

<script>
import PaginationNumbers from "./PaginationNumbers.vue";

export default {
  name: "PaginationTable.vue",
  components: { PaginationNumbers },
  data() {
    return {
      data: [],
      page: 0,
      totalItems: 0,
      itemsPerPage: 20,
    };
  },
  mounted() {
    this.getData(this.page);
  },

  methods: {
    refresh() {
      this.getData(this.page);
    },
    async getData(page) {
      try {
        this.$vs.loading();
        const result = await this.fetchData(page + 1);
        if (result.data) {
          this.data = result.data;
          this.totalItems =
            result.additional?.paginator?.total ?? result.meta?.total;
          this.itemsPerPage =
            result.additional?.paginator?.per_page ?? result.meta?.per_page;
        }
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    onChangedPage(page) {
      this.page = page;
      this.getData(page);
    },
    onClickItem(item) {
      this.$emit("onClickItem", item);
    },
  },
  props: {
    fetchData: {
      required: true,
      type: Function,
    },
    tableHeaders: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.table-wrapper {
  background-color: #ffffff;
  padding: 0;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 1px rgba(var(--vs-primary), 0.15);
  display: flex;
  flex-direction: column;

  .header {
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .table-content {
    overflow-x: auto;

    table {
      width: 100%;
      border-spacing: 0px;

      thead {
        tr {
          color: inherit;
          display: table-row;
          vertical-align: middle;
          outline: 0px;
          transition: background-color 0.2s ease 0s;
          background: rgba(203, 204, 210, 0.05);

          th {
            text-align: left;
            line-height: 1.5rem;
            display: table-cell;
            vertical-align: inherit;
            border-bottom: 1px solid rgba(203, 204, 210, 0.5);
            border-top: 1px solid rgba(203, 204, 210, 0.5);
            padding: 16px;
            text-transform: uppercase;
            font-size: 13px;
            font-weight: bold;
          }
        }
      }

      tbody {
        tr:nth-of-type(even) {
          background-color: rgba(203, 204, 210, 0.25);
        }

        tr:hover {
          transition: background-color 0.2s ease 0s;
          background-color: rgba(203, 204, 210, 0.05);
        }

        td {
          padding: 16px;
          font-size: 14px;
          line-height: 1.5;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: 700;
          border-bottom: 1px solid rgba(203, 204, 210, 0.5);
        }
      }
    }
  }

  .footer {
    display: flex;
    align-items: center;
  }
}
</style>
